export default __webpack_public_path__ + "static/media/excel.d65a5c4a.png";